var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"admin-content",attrs:{"id":"contact-search"}},[_c('Navbar'),_c('div',[_c('AddClientAgencyKogi')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }